import {IconButton, Tooltip} from '@material-ui/core'
import ViewColumnIcon from '@material-ui/icons/ViewColumn'
import ViewStreamIcon from '@material-ui/icons/ViewStream'
import useCore from 'modules/reports/hooks/core'
import React from 'react'
import useStyles from './ReportsDensity.styles'
import {useSearchContext} from 'modules/reports/hooks/search'

function ReportsDensity() {
  const classes = useStyles()
  const searchContext = useSearchContext()
  const {p, pt} = useCore('reports', 'components', 'Density')

  const {density} = searchContext.display

  const DENSITIES = [
    {
      key: 'compact',
      icon: ViewColumnIcon,
      iconClassName: classes.rotate90,
    },
    {
      key: 'comfortable',
      icon: ViewStreamIcon,
    },
  ]

  function selectDensity(density: string) {
    searchContext.setDisplay('density', density)
  }

  return (
    <div>
      {DENSITIES.map(item => {
        const densityClasses = [classes.button]
        if (item.key === density) densityClasses.push(classes.selectedButton)

        const label = pt(item.key)
        const IconC = item.icon

        return (
          <Tooltip key={item.key} title={label}>
            <IconButton
              className={densityClasses.join(' ')}
              onClick={() => selectDensity(item.key)}
              aria-label={label}
              data-testid={p(item.key)}
            >
              <IconC className={item.iconClassName} />
            </IconButton>
          </Tooltip>
        )
      })}
    </div>
  )
}

export default ReportsDensity
